// React import removed as it's not needed in modern React
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@shopify/polaris/build/esm/styles.css';

import { AppRoutes } from './routes/AppRoutes';
import { AuthProvider } from './contexts/AuthContext';
import { StoreProvider } from './contexts/StoreContext';
import { ShopifyProvider } from './contexts/ShopifyContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider i18n={{}}>
        <AuthProvider>
          <ShopifyProvider>
            <StoreProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </StoreProvider>
          </ShopifyProvider>
        </AuthProvider>
      </AppProvider>
    </QueryClientProvider>
  );
}

export default App; // Test auto-sync
